import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import DaumPostcode from "react-daum-postcode";

var themeObj = {
    bgColor: "#fbfbfd", //바탕 배경색
    searchBgColor: "#fff", //검색창 배경색
    contentBgColor: "#fff", //본문 배경색(검색결과,결과없음,첫화면,검색서제스트)
    pageBgColor: "#fff", //페이지 배경색
    textColor: "#333", //기본 글자색
    queryTextColor: "#222222", //검색창 글자색
    postcodeTextColor: "var(--main-color)", //우편번호 글자색
    emphTextColor: "var(--main-color)", //강조 글자색
    outlineColor: "#EFF1F4", //테두리
};

const postCodeStyle = {
    width: "100%",
    height: "500px",
    maxHeight: "60vh",
    padding: "0",
};

export const SearchAddress = ({ modalStatus, setAddress, setModalStatus, layerType = "active" }) => {
    const handleComplete = (data) => {
        document.body.classList.remove("hidden");
        setAddress(data);
        setModalStatus(false);
    };

    const showModal = () => {
        // window.scrollTo(0, 0);
        document.body.classList.add("hidden");
    };

    const hideModal = () => {
        document.body.classList.remove("hidden");
        setModalStatus(false);
    };

    useEffect(() => {
        showModal();
    }, []);

    return ReactDOM.createPortal(
        <>
            <div className={`layer ${layerType}`} onClick={hideModal}></div>

            <div className={modalStatus ? "modal modal-center modal-address_search active" : "modal modal-center modal-address_search"}>
                <DaumPostcode theme={themeObj} style={postCodeStyle} onComplete={handleComplete} autoClose />
            </div>
        </>,
        document.body
    );
};

export default SearchAddress;
